import { useState } from "react";

import { SlideInPanel } from "@design-system/SlideInPanel/SlideInPanel";
import { SortableList } from "@design-system/SortableList";

import {
  getColumnLabels,
  getDefaultColumnSettings,
} from "./ClientNotificationsTableColumns";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const ClientNotificationsTableColumnCustomization = ({
  isOpen,
  onClose,
}: Props) => {
  const [orderConfirmation, setOrderConfirmation] = useState(false);
  const [orderReset, setOrderReset] = useState(false);

  const handleApply = () => {
    setOrderConfirmation(true);
  };

  const handleReset = () => {
    setOrderReset(true);
  };

  const callbackOnClose = () => {
    setOrderConfirmation(false);
    setOrderReset(false);
  };

  return (
    <SlideInPanel
      isOpen={isOpen}
      onClose={onClose}
      onCancel={handleReset}
      onApply={handleApply}
      title="Column Settings"
      cancelButtonText="Reset"
      applyButtonText="Apply"
    >
      <SortableList
        orderingConfirmed={orderConfirmation}
        orderReset={orderReset}
        onClose={callbackOnClose}
        humanReadableNames={getColumnLabels()}
        defaultColumnSettings={getDefaultColumnSettings()}
      />
    </SlideInPanel>
  );
};